<template>
  <div class="page">
    <div
      v-for="(value, key, index) in newComponent.note.props"
      :key="index"
      class="page-title-div"
    >
      <a-tooltip placement="leftTop">
        <template slot="title">
          {{ key }}
        </template>
        <div class="page-title-div-text">{{ value.description || key }}</div>
      </a-tooltip>
      <div class="page-title-div-select">
        <div v-if="colorType.indexOf(value.type) > -1">
          <a-popover overlayClassName="chrome-picker" trigger="click" placement="bottom">
            <template slot="content">
              <chrome-picker style="width:100%;" :value="value.value.value || '#000000'" @input="colorChange($event, value.value)"></chrome-picker>
            </template>
            <div class="page-title-color" :style="{backgroundColor: value.value.value || '#000000'}"></div>
          </a-popover>
          
        </div>
        <div
          v-if="modalType.indexOf(value.type) > -1"
          @click="showModal(value)"
          class="page-title-but"
        >
          设置{{ value.type }}
        </div>
        <div v-if="selectType.indexOf(value.type) > -1">
          <a-select :value="value.value.value ? '0' : '1'" @change="selectChange($event, value.value)" style="width: 100%">
            <a-select-option value="0"> 是 </a-select-option>
            <a-select-option value="1"> 否 </a-select-option>
          </a-select>
        </div>
        <div v-if="inputType.indexOf(value.type) > -1">
          <a-input
            v-model="value.value.value"
            v-show="value.value.type == 'string'"
            :placeholder="dataText"
            @change="updatePageData"
          />
          <a-input
            v-model="value.value.value"
            :prefix="prefix"
            :suffix="suffix"
            v-show="value.value.type == 'code'"
            :placeholder="dataText_c"
            @change="updatePageData"
          />
        </div>
      </div>
      <div class="page-title-div-img">
        <img
          v-if="inputType.indexOf(value.type) > -1"
          @click="changeImg(value)"
          style="width: 100%; height: 100%"
          :src="value.value.type == 'code' ? img_c : img"
          alt=""
        />
      </div>
    </div>
    <!-- <a-row>
      <a-col :span="4" class="page-title-div-text" style="text-align: center">
        数字 
      </a-col>
      <a-col :span="10" :offset="1">
        <a-slider v-model="inputValue1" :min="1" :max="20" />
      </a-col>
      <a-col :span="4" :offset="2">
        <a-input-number
          v-model="inputValue1"
          :min="1"
          :max="20"
          style="marginleft: 16px"
        />
      </a-col>
    </a-row> -->
    

    <a-button @click="setComponent">保存</a-button>
    <!-- 列表弹窗 -->
    <a-modal
      style="width: 60%"
      v-model="showModalState"
      :title="modalProp.type"
      on-ok="handleOk"
    >
      <textarea
        v-if="modalProp.type != 'Color'"
        ref="modalText"
        v-model="modelValue"
        class="textarea-div"
      ></textarea>
      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >
          确认提交
        </a-button>
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
      </template>
    </a-modal>
    <!-- 颜色弹窗 -->
    <!-- <a-modal
      style="width: 60%"
      v-model="showColorModalState"
      title="选择颜色"
      on-ok="handleOk"
    >
      
      <template slot="footer">
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >
          确认提交
        </a-button>
        <a-button key="back" @click="handleCancel"> 取消 </a-button>
      </template>
    </a-modal> -->
  </div>
</template>

<script>
import jsonp from "fetch-jsonp";
import querystring from "querystring";

import { Chrome } from 'vue-color'

import BlockComponent from "@/utils/BlockComponent.js";
import bus from "@/utils/Bus";

export default {
  name: "RightAttribute",
  props: {
    component: {
      type: Object,
      default: new BlockComponent(),
    },
  },
  components: {
    ChromePicker: Chrome,
    // PhotoShop,
  },
  data() {
    return {
      inputValue1: 1,
      modalProp: { value: { value: "" } },
      newComponent: {
        note: {
          props: {}
        }
      },
      modelValue: "",
      modalProp: { value: { value: "" } },
      inputType: ["String", "Number", "Function"],
      selectType: ["Boolean"],
      modalType: ["Array", "Object"],
      colorType: ["Color"],
      value: undefined,
      img: require("@/assets/edit-page/js-c.png"),
      img_c: require("@/assets/edit-page/js.png"),
      dataText: "请输入字符串",
      dataText_c: "请输入JS表达式",
      visible: true,
      visibleNum: true,
      visibleNumTwo: true,
      showModalState: false,
      showModalState2: false,
      loading: false,
      loading2: false,
      prefix: "{{",
      suffix: "}}",
    };
  },
  watch: {
    colors: {
      handler(value) {
        console.log(`colors变化: `, value);
      },
      deep: true,
    },
    component: {
      async handler(component) {
        console.log(`属性面板监听到props component 变化: `, component.note);
        this.newComponent = _.cloneDeep(component);
      },
      deep: true,
    },
  },
  mounted() {
    let self = this;
  },
  methods: {
    colorChange(color, value ) {
      if(color.a == 1){
        value.value = color.hex
      }else{
        value.value = color.hex8
      }
      console.log('new color', value.value)
      this.updatePageData()
    },
    setComponent() {
      bus.$emit("update-component", this.newComponent);
      bus.$emit("save-component", this.newComponent);
    },
    selectChange(select, value) {
      value.value = select == "0"
      this.updatePageData()
      console.log('new select', select)
    },
    handleOk() {
      try {
        this.modalProp.value.value = JSON.parse(this.modelValue)
      } catch (error) {
        this.$message.warning("格式不正确！")
        return
      }
      this.updatePageData()
      console.log('new obj list', this.modalProp)
      this.showModalState = false;
    },
    updatePageData(){
      let changeData = {topicDict: {}}
      changeData.topicDict[this.component.key] = {note: {props: this.newComponent.note.props}}
      bus.$emit("post-message", changeData, "update-page-data");
      bus.$emit("update-component", this.newComponent);
    },
    handleCancel() {
      this.showModalState = false;
    },
    changeImg(prop) {
      prop.value.type = prop.value.type == "code" ? "string" : "code";
    },
    showModal(prop) {
      // this.updatePageData()
      this.modalProp = prop;
      this.modelValue = JSON.stringify(this.modalProp.value.value, null, 2)
      this.showModalState = true;
    },
  },
};
</script>

<style scoped>
@import "index.css";
</style>
